export const LOGIN_WEB = "login_web";
export const LOGIN_DESKTOP = "login_desktop";
export const SUBMIT_REVIEW = "submit_review";
export const BULK_SUBMIT_REVIEW = "bulk_submit_review";
export const ACCESS_ACCURACY_REPORT = "access_accuracy_report";
export const ACCESS_OWN_ACCURACY_REPORT = "access_own_accuracy_report";
export const FALSE_REJECT = "false_reject";
export const ADD_COMMENTS = "add_comments";
export const REJECT = "reject";
export const MANAGE_FILE_HISTORY = "manage_file_history";
export const MANAGE_DELETED_FILE = "manage_deleted_file";
export const MANAGE_IMPORTED_FILE = "manage_imported_file";
export const MANAGE_CLIENTS = "manage_clients";
export const MANAGE_WORKFLOWS = "manage_workflows";
export const MANAGE_METADATA = "manage_meta_data";
export const MANAGE_DEPARTMENTS = "manage_departments";
export const MANAGE_ROLES = "manage_roles";
export const MANAGE_USERS = "manage_users";
export const MANAGE_TEAMS = "manage_teams";
export const UPLOAD_DOCS_TO_CLOUD = "upload_docs_to_cloud";
export const UPLOAD_DOCS_TO_ADAPTER = "upload_docs_to_adapter";
export const APPROVE = "approve";
export const BULK_APPROVE = "bulk_approve";
export const USE_LENS_AI = "use_lens_ai";
export const MANAGE_AI = "manage_ai";
